import type {
  DemoDataResetRequest,
  DemoDataResetProfileInput,
} from "../../../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
import type { DemoResetProfileOutput } from "../../../../../_shared/_logic/demo-data-reset-contract"

const profilePayload = (profile: DemoResetProfileOutput): DemoDataResetProfileInput => ({
  access_email: profile.accessEmail,
  password: profile.password,
  reuse_user_id: profile.password ? null : profile.reuseUserId,
  contact_email: profile.contactEmail,
  contact_mobile: profile.contactMobile,
})

export const buildDemoResetRequest = (
  admin: DemoResetProfileOutput,
  employee: DemoResetProfileOutput,
): DemoDataResetRequest => ({
  preset_key: "sales_v1",
  confirmation: "DEMO RESET",
  profiles: {
    admin: profilePayload(admin),
    employee: profilePayload(employee),
  },
  base_date: null,
  calendar_projection: false,
  target_plan_family: "kehrtalk",
})
